module.exports = __webpack_public_path__ + "img/select04.64d31a26.png";